module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-left-5.c381f4ff.png";